export const subStringTH = (msg, length) =>{
  let upperLowerVowel = [ 'ั',  'ิ', 'ี', 'ุ', 'ู', 'ึ', 'ื', '่', '้', '๊', '๋', '็', '์', 'ํ', 'ฺ', '์', '๎' ]
  const charArr = [...msg]
  
  let result = ''
  let i = 0
  let runLenght = 0
  while (runLenght < length && i < charArr.length){
    result += charArr[i]
    if (!upperLowerVowel.includes(charArr[i])){
      runLenght++
    }
    i++
  }
  return result
}